@import 'styles/mixins';
@import 'styles/blaze/mixins';

.container {
  background-color: var(--blaze-pale-light-yellow);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 409px;
  min-height: 750px;
  height: auto;
  width: 100%;

  .content {
    background-color: var(--blaze-pale-light-yellow);
    display: flex;
    flex-direction: column;
    gap: 100px;
    height: 100%;
    max-width: 530px;
    margin: 0 auto;

    @include for-tablet-portrait-max {
      padding: 24px 20px 24px 20px;
      gap: 28px;
      flex-grow: 1;
      justify-content: space-between;
      width: 100%;
      align-items: center;
    }

    .bottomContent {
      display: flex;
      flex-direction: column;
      gap: 32px;
      width: 100%;
    }
  }

  @include for-tablet-portrait-max {
    margin: 0;
    border: none;
    width: 100%;
    min-height: 100vh;
    padding: 0;
  }

  .steps {
    display: flex;
    flex-direction: column;
    padding: 32px 30px 24px 30px;
    align-items: flex-start;
    gap: 48px;

    @include for-tablet-portrait-max {
      gap: 52px;
    }
  }

  .header {
    width: 100%;
    font-weight: 400;
  }

  .heading {
    @include md-sohne;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
  }

  .text {
    div {
      @include sm-sohne;
    }
  }

  .title {
    text-align: center;
    width: 100%;
    text-transform: none;
  }

  .step {
    display: flex;
    gap: 20px;
    align-items: center;
    z-index: 1;
    position: relative;

    @include for-tablet-portrait-max {
      gap: 14px;
      min-height: 62px;
    }

    .icon {
      border-radius: 50%;
      background-color: var(--blaze-pale-light-yellow);
      border: 1px solid var(--neutral-90);
      min-width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;

      &.filled {
        background: var(--blaze-bright-green);
      }

      svg {
        margin-right: 2px;
      }
    }
  }

  .connector {
    position: absolute;
    top: 12px;
    left: 17px;
  }

  .stepOneIcon {
    path {
      fill: var(--neutral-0);
    }
  }

  .stepTwoIcon {
    path:first-of-type {
      fill: var(--blaze-pale-light-yellow);
    }
  }

  .stepThreeIcon {
    rect:first-of-type,
    circle,
    path:last-of-type {
      fill: var(--blaze-pale-light-yellow);
    }
  }

  .submitButton {
    width: 100%;
  }

  .smallPrint {
    @include xxs-medium;
    font-weight: 400;
    color: var(--neutral-40);
    text-align: center;
    width: 100%;
    margin-top: -20px;
  }
}
